import { Question } from 'survey-core';
import { SurveyQuestionElementBase } from 'survey-react-ui';

export class UploadMediaQuizQuestion extends Question {
   get mediaType() {
      return this.getPropertyValue('mediaType');
   }
   set mediaType(val) {
      this.setPropertyValue('mediaType', val);
   }
   get imageId() {
      return this.getPropertyValue('imageId');
   }
   set imageId(val) {
      this.setPropertyValue('imageId', val);
   }
   get altText() {
      return this.getPropertyValue('altText');
   }
   set altText(val) {
      this.setPropertyValue('altText', val);
   }
   get caption() {
      return this.getPropertyValue('caption');
   }
   set caption(val) {
      this.setPropertyValue('caption', val);
   }
}

export class QuizQuestionMediaUploader extends SurveyQuestionElementBase {
   constructor(props: any) {
      super(props);
      this.state = { value: this.question.value };
   }

   get question() {
      return this.questionBase;
   }
   get value() {
      return this.question.value;
   }

   get mediaType() {
      return this.question.mediaType;
   }
   get imageId() {
      return this.question.imageId;
   }
   get altText() {
      return this.question.altText;
   }
   get caption() {
      return this.question.caption;
   }
}
